import { useRouter } from 'next/router';
import { logger } from '@zep/core-logger';
import { SpaceWithPlanDto } from '../../../../../types/SubscriptionType';
import { useGoSubscriptionPayment } from '../../hooks';
export const useExpiredButtons = (space: SpaceWithPlanDto) => {
  const router = useRouter();
  const move = useGoSubscriptionPayment();
  const {
    spaceHashId
  } = space;
  const handleClickUpgradePlan = () => {
    move({
      spaceHashId
    });
    logger.track('home_subscription_plan_upgrade', {
      place: 'spaces'
    });
  };
  const handleClickManagePlan = () => {
    router.push({
      pathname: '/me/spaces/[hashId]/plan',
      query: {
        hashId: spaceHashId
      }
    });
  };
  return {
    handleClickUpgradePlan,
    handleClickManagePlan
  };
};